import { Movement } from "../domain/Movement";
import { MovementId } from "../domain/MovementId";
import { MovementRepository } from "../domain/MovementRepository";

export async function getFullMovementByCompanyAndId(
  movementRepository: MovementRepository,
  companyId: string,
  movementUid: string
): Promise<Movement> {
  const movementId = new MovementId(movementUid);
  const movement = await movementRepository.getMovementFullByCompanyAndId(companyId.toString(),movementId.toString());
  if (movement === undefined) {
    throw new Error("Movement not found");
  } else {
    return movement;
  }
}
